import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Chift\DeleteCompanyConnexionController::__invoke
* @see app/Http/Controllers/Chift/DeleteCompanyConnexionController.php
* @route '/api/company/{company}/chift/connexion/{connexion_id}'
*/
const DeleteCompanyConnexionController = (args: { company: string | number | { id: string | number }, connexion_id: string | number } | [company: string | number | { id: string | number }, connexion_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteCompanyConnexionController.url(args, options),
    method: 'delete',
})

DeleteCompanyConnexionController.definition = {
    methods: ["delete"],
    url: '/api/company/{company}/chift/connexion/{connexion_id}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Chift\DeleteCompanyConnexionController::__invoke
* @see app/Http/Controllers/Chift/DeleteCompanyConnexionController.php
* @route '/api/company/{company}/chift/connexion/{connexion_id}'
*/
DeleteCompanyConnexionController.url = (args: { company: string | number | { id: string | number }, connexion_id: string | number } | [company: string | number | { id: string | number }, connexion_id: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            company: args[0],
            connexion_id: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
        connexion_id: args.connexion_id,
    }

    return DeleteCompanyConnexionController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace('{connexion_id}', parsedArgs.connexion_id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Chift\DeleteCompanyConnexionController::__invoke
* @see app/Http/Controllers/Chift/DeleteCompanyConnexionController.php
* @route '/api/company/{company}/chift/connexion/{connexion_id}'
*/
DeleteCompanyConnexionController.delete = (args: { company: string | number | { id: string | number }, connexion_id: string | number } | [company: string | number | { id: string | number }, connexion_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteCompanyConnexionController.url(args, options),
    method: 'delete',
})

export default DeleteCompanyConnexionController